import { Tooltip } from "@mui/material";
import BrandAvatar from "../../Component/Avatar/Avatar";
import classes from "./CategoryMonitoring.module.css";
import { TOOLTIP_SX, withDisplayRanks, RankBreakdownTooltip } from "./consensus-utils";

export default function CMPodiumConsensus({ title, entries, domainMap = {}, rankLabels }) {
  const ranked = withDisplayRanks(entries);

  const top3 = ranked.slice(0, 3).map((entry, i) => ({ ...entry, podiumSlot: i + 1 }));
  const rest = ranked.slice(3);
  const podiumOrder = [top3[1], top3[0], top3[2]].filter(Boolean);

  const PODIUM_SLOT_CLASS = {
    1: classes.podiumBarFirst,
    2: classes.podiumBarSecond,
    3: classes.podiumBarThird,
  };

  return (
    <div className={classes.consensusCardWide}>
      <div className={classes.consensusCardHeader}>
        <span className={classes.consensusCardLabel}>{title}</span>
      </div>

      {ranked.length > 0 ? (
        <div className={classes.podiumWrap}>
          <div className={classes.podiumCards}>
            {podiumOrder.map((entry) => (
              <Tooltip
                key={entry.name}
                title={<RankBreakdownTooltip name={entry.name} ranks={entry.ranks} rankLabels={rankLabels} />}
                arrow
                placement="top"
                componentsProps={{ tooltip: { sx: TOOLTIP_SX } }}
              >
                <div className={classes.podiumBarCol}>
                  <div className={classes.podiumHeader}>
                    <div className={classes.podiumAvatar}>
                      <BrandAvatar domainName={domainMap[entry.name] || "example.com"} brandName={entry.name} />
                    </div>
                    <span className={classes.podiumName}>{entry.name || "—"}</span>
                  </div>
                  <div className={`${classes.podiumBar} ${PODIUM_SLOT_CLASS[entry.podiumSlot] || ""}`}>
                    <span className={classes.podiumBarRank}>{entry.displayRank}</span>
                  </div>
                </div>
              </Tooltip>
            ))}
          </div>

          {rest.length > 0 && (
            <div className={classes.podiumList}>
              {rest.map((entry, index) => (
                <Tooltip
                  key={entry.name || index}
                  title={<RankBreakdownTooltip name={entry.name} ranks={entry.ranks} rankLabels={rankLabels} />}
                  arrow
                  placement="left"
                  componentsProps={{ tooltip: { sx: TOOLTIP_SX } }}
                >
                  <div className={classes.podiumListRow}>
                    <span className={classes.podiumListRank}>{entry.displayRank}</span>
                    <div className={classes.chartAvatar}>
                      <BrandAvatar domainName={domainMap[entry.name] || "example.com"} brandName={entry.name} />
                    </div>
                    <span className={classes.podiumListName}>{entry.name || "—"}</span>
                  </div>
                </Tooltip>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className={classes.consensusRow}>
          <span className={classes.consensusName}>No data</span>
        </div>
      )}
    </div>
  );
}
